import React from 'react';

export const withSuspense = (ComponentToWrap, Loading) => (props) => {
  const isSSR = typeof window === 'undefined';

  return (
    <>
      {!isSSR ? (
        <React.Suspense fallback={Loading}>
          <ComponentToWrap {...props} />
        </React.Suspense>
      ) : (
        Loading
      )}
    </>
  );
};
